import { useQueryShopifyCurrencyRates } from '~/modules/shopify/hooks/useQueryShopifyCurrencyRates';
import { captureSentryError } from '~/exceptions/sentry';
import { useAnalyticStore } from '~/modules/analytics';
import { useShopStore } from '~/stores/shop';

export const useFetchCurrencyRates = () => {
  const setCurrencyRates = useAnalyticStore((state) => state.setCurrencyRates);
  const currencyRates = useAnalyticStore((state) => state.currencyRates);
  const shopInfo = useShopStore((state) => state.shopInfo);

  useQueryShopifyCurrencyRates(undefined, {
    enabled: !!shopInfo?.token,
    onSuccess: (response) => {
      setCurrencyRates(response.data);
    },
    onError: (error) => {
      captureSentryError(error, {
        source: 'useFetchCurrencyRates',
        tags: { analytic: 'Analytic' },
      });
    },
  });
  return { currencyRates };
};
